export enum ThemeStyle {
  MODERN = 'modern',
  STANDARD = 'standard',
}

export enum ThemeStyleRadius {
  MODERN = 30,
  STANDARD = 4,
}

export enum ThemeMode {
  LIGHT = 'light',
  SEMI_DARK = 'semi-dark',
  DARK = 'dark',
}

export enum LayoutType {
  BOXED = 'boxed',
}

export enum NavStyle {
  HOR_LIGHT_NAV = 'hor-light-nav',
}

export enum FooterType {
  FIXED = 'fixed',
  FLUID = 'fluid',
}

export enum RouteTransition {
  NONE = 'none',
  FADE = 'fade',
  SLIDE_LEFT = 'slideLeft',
  SLIDE_RIGHT = 'slideRight',
  SLIDE_UP = 'slideUp',
  SLIDE_DOWN = 'slideDown',
}

export enum Fonts {
  LIGHT = 'Chakra Petch',
  REGULAR = 'Chakra Petch Regular',
  MEDIUM = 'Chakra Petch Medium',
  BOLD = 'Chakra Petch Bold',
  EXTRA_BOLD = 'Chakra Petch ExtraBold',
}
